export default __webpack_public_path__ + "images/nvent-raychem-sidebyside-logo@2x.png?f77ad9d17925940b6d834a2244e9694a";